import React from "react";
import { Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";

import LazyEditorOutput from "components/editor/LazyEditorOutput";
import getUserName from "app/utils/getUserName";

const CommentBody = ({ comment: { user, body }, hideLinks = false }) => (
  <div className="comment-body">
    {hideLinks ? (
      <div className="comment-author">
        <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
        {" "}
        {getUserName(user)}
      </div>
    ) : (
      <ProfileLink user={user} className="comment-author">
        <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
        {" "}
        {getUserName(user)}
      </ProfileLink>
    )}
    {" "}
    <LazyEditorOutput output={body} showTags={false} />
  </div>
);

export default CommentBody;
